import { useMemo} from 'react';

export const CUSTOM_EMAIL_DOMAIN = {
  label: '직접입력',
  key: 'custom',
  value: 'custom',
};

export const EMAIL_DOMAIN = [
  CUSTOM_EMAIL_DOMAIN,
  {
    label: 'samsung.com',
    key: 'samsung',
    value: 'samsung.com',
  },
  {
    label: 'partner.samsung.com',
    key: 'partnerSamsung',
    value: 'partner.samsung.com',
  },
  {
    label: 'gmail.com',
    key: 'google',
    value: 'gmail.com',
  },
  {
    label: 'naver.com',
    key: 'naver',
    value: 'naver.com',
  },
  {
    label: 'hanmail.net',
    key: 'daum',
    value: 'hanmail.net',
  },
  {
    label: 'korea.com',
    key: 'korea',
    value: 'korea.com',
  },
];

export const useEmailDomainList = (codeDetail, siteNumber) => {
    var emailDomainList = useMemo ( 
      () => codeDetail?.filter(({ groupCode1, groupCode2, groupCode3, groupCode4, groupCode5 }) => {
        // [WIP-27817] 공통코드 'ST2005' 에 상세 코드에 groupCode2, groupCode3, groupCode4, groupCode5 중 하나라도 siteNumber와 일치하면 제외 되도록 수정
        const excludedSiteNumbers = [groupCode2, groupCode3, groupCode4, groupCode5];

        return (groupCode1 === siteNumber || groupCode1 === '0000000000') && !excludedSiteNumbers.includes(siteNumber);
      }).map(({ codePath, codeName}) => (
        { 
          label: codePath,
          key: codeName,
          value: codePath,
        }
        )
      ),
        [codeDetail, siteNumber]
    );

    return {
      emailDomainList,
    };
  };

export const MAX_EMAIL_ID_LENGTH = 100;
export const MAX_EMAIL_DOMAIN_LENGTH = 100;
